module.exports = __webpack_public_path__ + "static/media/HRECOS_Stations_Piermont.7752d397.jpg";